<div
    #tooltipText
    class="text"
    [nz-tooltip]="text"
    [nzTooltipOverlayStyle]="showTooltip ? {} : { display: 'none' }"
    (mouseenter)="mouseEnter()"
    (click)="clickLink();$event.stopPropagation();"
    [class]="isLink ? 'link-text' : 'default-text'"
    [innerHTML]="html || text"
></div>
